{
    "button": {
        "signin": "Se connecter",
        "open": "Ouvrir",
        "close": "Fermer",
        "submit": "Valider",
        "previous": "Précédent",
        "next": "Suivant",
        "reset": "Effacer",
        "yes": "Oui",
        "no": "Non",
        "filter": "Filtrer",
        "reset_filters": "Effacer les filtres",
        "search": "Rechercher",
        "select_all_page": "Sélectionnez toute la page",
        "switch_version": "Version Bêta"
    },
    "page": {
        "dashboard": {
            "title": "Tableau de bord"
        },
        "documentation": {
            "title": "Documentation"
        },
        "envelopes": {
            "title": "Enveloppes",
            "tabs": {
                "envelopes": "Enveloppes",
                "downloadCodes": "Codes de téléchargement"
            }
        },
        "historics": {
            "title": "Historiques",
            "tabs": {
                "pos_terminals": "Terminaux",
                "sim_cards": "Cartes SIM",
                "users": "Utilisateurs"
            }
        },
        "home": {
            "title": "Accueil"
        },
        "merchant_accounts": {
            "title": "Comptes marchand",
            "details": {
                "title": "Détails du compte marchand",
                "tabs": {
                    "merchant_users": "Utilisateurs marchand",
                    "merchant_contracts": "Contrats marchand",
                    "customization": "Personnalisation",
                    "subscriptions": "Terminaux",
                    "beneficiaries": "Bénéficiaires"
                }
            }
        },
        "newsletter": {
            "title": "Nouveautés"
        },
        "organization": {
            "title": "{{socialReason}} ($t(organization:type.{{organizationType}}))",
            "short": "Détails de l'organisation",
            "tabs": {
                "details": "Détails",
                "users": "Utilisateurs",
                "direct_organizations": "Sous-organisations",
                "subscriptions": "Terminaux",
                "remote_collections": "Remises",
                "parent_plans": "Offres fournisseur",
                "sim_cards": "Cartes SIM"
            },
            "accordions": {
                "details": "Détails",
                "connection_points": "Points de connexion",
                "legal_infos": "Informations légales",
                "white_label_customization": "Personnalisation",
                "alerts": "Alertes",
                "sim_offers": "Forfaits SIM"
            }
        },
        "organizations": {
            "title": "Organisations",
            "tree_tmp": "Arbre des organisations"
        },
        "plans": {
            "title": "Catalogue d'offres",
            "details": {
                "title": "Détails de l'offre"
            },
            "accordions": {
                "details": "Détails de l'offre",
                "allowed_clients": "Clients autorisés"
            }
        },
        "push_payments": {
            "title": "Push Payment API",
            "tabs": {
                "partners": "Organisations partenaires",
                "notif_rules": "Règles de notifications"
            }
        },
        "remote_collection": {
            "title": "Remises",
            "details": {
                "title": "Détails de la remise"
            },
            "transaction": {
                "title": {
                    "full": "Remise n°{{reconciliationNumber}} (contrat {{application}} n°{{number}})",
                    "without_application": "Remise n°{{reconciliationNumber}} (contrat n°{{number}})",
                    "without_reconciliation_number": "Remise (contrat {{application}} n°{{number}})",
                    "contract_only": "Contrat n°{{number}}",
                    "short": "Remise"
                }
            }
        },
        "rentalFiles": {
            "title": "Dossiers PLBS",
            "details": {
                "title": "Détails du dossier n°{{fileNumber}}",
                "title_short": "Détails du dossier",
                "breadcrumb": "n°{{fileNumber}}"
            }
        },
        "searchContracts": {
            "title": "Recherche"
        },
        "sim_cards": {
            "title": "Cartes SIM",
            "tabs": {
                "sims": "Cartes SIM",
                "simPools": "Groupes de SIM"
            }
        },
        "sim_card": {
            "title": "Détails de la carte SIM",
            "details": {
                "full": "n° {{iccid}}",
                "short": "Détails de la carte SIM"
            }
        },
        "sim_group": {
            "title": "Détails du groupe de SIM"
        },
        "subscriptions": {
            "title": "Terminaux",
            "tabs": {
                "pos_terminals": "Terminaux",
                "payludd_pos_terminals": "Terminaux Payludd"
            }
        },
        "subscription": {
            "title": "Détails de l'abonnement",
            "details": {
                "full": "n° {{serialNumber}}",
                "short": "Détails de l'abonnement"
            },
            "tabs": {
                "details": "Détails",
                "contracts": "Contrats",
                "connections": "Connexions",
                "transactions": "Transactions",
                "remote_collections": "Télécollectes"
            },
            "accordions": {
                "subscription": "Abonnement passerelle",
                "terminal": "Terminal",
                "connection": "Connexion",
                "payludd_terminal_state": "Payludd - État du terminal"
            }
        },
        "users": {
            "title": "Utilisateurs monétique",
            "details": {
                "title": "Détails de l'utilisateur monétique"
            },
            "accordions": {
                "details": "Détails de l'utilisateur",
                "permissions": "Permissions"
            }
        },
        "payludd": {
            "customization": {
                "creation": {
                    "title": "Nouvelle Personnalisation Payludd"
                },
                "management": {
                    "title": "Gestion de la personnalisation Payludd"
                },
                "accordions": {
                    "details": "Identifiant",
                    "colors": "Couleur et logo",
                    "payludd_app_settings": "Fonctionnalités",
                    "monetic_settings": "Configuration monétique"
                }
            }
        }
    },
    "sidebar": {
        "root_organization_helper": "Organisation racine",
        "menu": {
            "group_1": {
                "label": "Portail monéticien",
                "rootEntity": {
                    "configuration": "Configuration",
                    "exploitation": "Exploitation",
                    "parc": "Parc"
                }
            },
            "group_2": {
                "label": "Ressources"
            }
        },
        "actions": {
            "manage_user_account": "Gérer le compte",
            "secure_access": "Securiser l'accès",
            "login_sign_out": "Se déconnecter",
            "previous": "Précédent"
        }
    },
    "date_picker": {
        "before_date": "Avant le ",
        "after_date": "Après le ",
        "before_time": "Avant le {{to}} à",
        "after_time": "Après le {{from}} à",
        "select_time": "Sélectionnez une heure",
        "from_time": "Du {{from}} à",
        "from_time_no_date": "Date de départ non définie",
        "to_time": "Au {{to}} à",
        "to_time_no_date": "Date de fin non définie",
        "local_time_zone": "(heure locale du TPE)",
        "options": {
            "before": "Avant cette date",
            "after": "Après cette date",
            "select": "Période"
        }
    },
    "number_filter": {
        "filter_by": {
            "amount": "Filtrer par montant",
            "number": "Filtrer par nombre"
        },
        "MORE": "Supérieur ou égal à",
        "LESS": "Inférieur ou égal à",
        "EQUAL": "Égal à",
        "RANGE": {
            "title": "Intervalle",
            "between": "Entre",
            "and": "et"
        },
        "badge": {
            "equal": "Égal à {{value}}",
            "more": "Supérieur ou égal à {{value}}",
            "less": "Inférieur ou égal à {{value}}",
            "range": "Entre {{value0}} et {{value1}}"
        }
    },
    "table": {
        "column": {
            "manager": "Gestionnaire de colonne"
        },
        "filter": {
            "placeholder": "Sélectionner un filtre",
            "filter_by": "Sélectionner une valeur"
        },
        "no_result": "Pas de résultat",
        "deselect_all": "Tout désélectionner",
        "results": "{{results}} résultats",
        "pagination": {
            "pageCount": "sur {{pageCount}}",
            "rowSelected": "{{rowSelected}} de {{rowCount}} ligne(s) sélectionnée(s)."
        },
        "actions": {
            "export": "Exporter",
            "import": "Importer"
        },
        "error": {
            "timeout_retry": "Merci de patienter quelques instants...",
            "timeout_after_retry": "Une erreur est survenue lors du chargement de la table. Votre requête n'a pas pu aboutir.",
            "bad_gateway": "Echec du chargement. Veuillez réessayer ultérieurement",
            "loading": "Une erreur est survenue lors du chargement de la table"
        }
    },
    "select": {
        "default": "Choisir une option",
        "no_options": "Aucune option disponible"
    },
    "toast": {
        "loading": "Chargement...",
        "success": "Opération réussie",
        "error": "Une erreur est survenue"
    },
    "title": {
        "permissions": {
            "access_denied": "Vous n'avez pas accès à cette fonctionnalité"
        },
        "copy": {
            "click": "Cliquer pour copier",
            "copied": "Texte copié"
        }
    },
    "form": {
        "ranks": {
            "free_input": "Format invalide",
            "digits_input": "Format invalide"
        },
        "alma": {
            "api_key": "Veuillez introduire une clé API",
            "label": "Caractères spéciaux et accents interdits"
        },
        "cbvad": {
            "contract_label": "La chaine est trop longue !",
            "contract_number": "Le numéro de contrat doit contenir de 1 à 15 chiffres",
            "rank": "Le rang doit contenir exactement 3 chiffres",
            "bank_code": "Le code banque doit contenir exactement 5 chiffres",
            "x25_address": "L'adresse doit contenir au plus 50 chiffres"
        },
        "validation": {
            "email": {
                "invalid": "Veuillez entrer une adresse email valide"
            }
        }
    },
    "modal": {
        "function_not_activated": {
            "text": "Cette fonctionnalité est en cours de développement"
        },
        "send_mail": {
            "maximum_mails": "({{number}} adresses mail maximum)",
            "placeholder": "Entrer une adresse ici...",
            "already_exists": "Ce mail existe déjà !",
            "validate": "Validez pour terminer",
            "add_address": "Ajouter une adresse",
            "remove_address": "Effacer cette adresse",
            "confirm": {
                "single": "Le mail va être envoyé au destinataire suivant :",
                "multiple": "Le mail va être envoyé aux destinataires suivants :"
            },
            "steps": {
                "input": "Étape {{step}} sur {{maxStep}} : Saisie des emails",
                "confirm": "Étape {{step}} sur {{maxStep}} : Confirmation"
            }
        },
        "export": {
            "title": "Exporter ces résultats",
            "emails": "Un lien de téléchargement sera envoyé par mail",
            "link_validity": "Le lien est valide pendant 48 heures",
            "sending_confirmation": "Votre demande a bien été prise en compte. L’envoi de l’export sera fait d’ici quelques minutes.",
            "error": "Une erreur est survenue. Si l'erreur persiste, veuillez contactez le support.",
            "on_timeout": {
                "confirmation_title": "Exporter les résultats",
                "confirmation_body": "Souhaitez-vous exporter les résultats et les recevoir par email ?",
                "confirmation_confirm": "Oui",
                "confirmation_cancel": "Non"
            }
        },
        "import": {
            "title": "Opérations par fichier",
            "steps": {
                "file_upload": "Étape {{step}} sur {{maxStep}} : Téléchargement du fichier",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "file_errors": "Des erreurs ont été détectées dans le fichier."
        }
    },
    "units": {
        "data": {
            "byte": "{{dataUsage}} o",
            "k_byte": "{{dataUsage}} Ko",
            "m_byte": "{{dataUsage}} Mo",
            "g_byte": "{{dataUsage}} Go"
        }
    },
    "civility": {
        "mr": "M.",
        "mrs": "Mme",
        "miss": "Mlle"
    },
    "file_upload": {
        "label": "Un modèle avec des exemples est disponible au téléchargement.",
        "default": {
            "file_example": "Télécharger un modèle",
            "button": "Parcourir les fichiers",
            "cannot_read_file": "Impossible de lire le fichier",
            "invalid_file": "Fichier invalide",
            "invalid_size_file": "Fichier trop volumineux"
        }
    },
    "documentation": {
        "api_documentation": "APIs",
        "user_guide": "Guide monéticien",
        "user_merchant_guide": "Guide marchand",
        "payludd_guide": "Notice d'initialisation Payludd",
        "merchant_payludd_guide": "Notice d'utilisation commerçant"
    },
    "posthog": {
        "consent_banner": {
            "title": "Nous utilisons des cookies de suivi pour comprendre comment vous utilisez le portail et nous aider à l'améliorer.",
            "accept": "Accepter les cookies",
            "decline": "Refuser les cookies"
        }
    }
}